module.exports = __webpack_public_path__ + "img/Arrow_right_bl.53c3a127.svg";